<template>
  <div class="pi-obc">
    <dl class="pi-obc__facts">
      <div class="pi-obc__fact">
        <dt>Venda (D0) <pi-definition-tooltip info-key="activation.soldAt" label="Venda (D0)"/></dt>
        <dd>
          {{ company.soldText }}
          <span v-if="company.approximate" class="pi-badge pi-badge--info">D0 aproximado</span>
          <span v-if="company.unsold" class="pi-badge pi-badge--muted">não vendida</span>
          <span class="pi-table__sub">{{ company.soldSource.label }}</span>
        </dd>
      </div>
      <div class="pi-obc__fact"><dt>Trial antes da venda <pi-definition-tooltip info-key="activation.trialDays" label="Trial antes da venda"/></dt><dd>{{ company.trialText }}</dd></div>
      <div class="pi-obc__fact"><dt>Hoje <pi-definition-tooltip info-key="activation.daysSinceSale" label="Hoje"/></dt><dd>{{ company.daysText }}</dd></div>
      <div class="pi-obc__fact">
        <dt>Etapa <pi-definition-tooltip info-key="activation.stageNow" label="Etapa"/></dt>
        <dd>{{ company.stageText }}<span v-if="company.skippedSetup" class="pi-table__sub">pulou a configuração</span></dd>
      </div>
      <div class="pi-obc__fact">
        <dt>Situação <pi-definition-tooltip info-key="activation.situation" label="Situação"/></dt>
        <dd>
          <span class="pi-badge" :class="'pi-badge--' + view.situation.tone">{{ view.situation.label }}</span>
          <span v-if="view.situation.detail" class="pi-table__sub">{{ view.situation.detail }}</span>
        </dd>
      </div>
      <div class="pi-obc__fact">
        <dt>Habilitados ÷ assentos <pi-definition-tooltip info-key="activation.seats" label="Habilitados ÷ assentos"/></dt>
        <dd>
          {{ company.seatsText }}
          <span v-if="company.seatsShareText" class="pi-table__sub">{{ company.seatsShareText }}</span>
          <span v-if="company.registeredText" class="pi-table__sub">{{ company.registeredText }}</span>
        </dd>
      </div>
      <div class="pi-obc__fact"><dt>1ª e última batida <pi-definition-tooltip info-key="activation.punches" label="1ª e última batida"/></dt><dd>{{ company.punchesText }}</dd></div>
      <div class="pi-obc__fact"><dt>Batida 7d <pi-definition-tooltip info-key="activation.punch7d" label="Batida 7d"/></dt><dd>{{ company.punch7dText }}</dd></div>
    </dl>

    <h3 class="pi-subtitle">Marcos</h3>
    <pi-onboarding-checklist :milestones="view.timeline" :skipped-setup="view.skippedSetup"/>

    <h3 class="pi-subtitle">D15, D30 e D60</h3>
    <div class="pi-table-wrap">
      <table class="pi-table">
        <caption class="pi-sr">Valores gravados em cada janela da empresa</caption>
        <thead>
        <tr>
          <pi-th v-for="column in windowColumns" :key="column.key" :column="column"/>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in view.windows" :key="row.key">
          <th scope="row">{{ row.label }}</th>
          <td><span class="pi-badge" :class="'pi-badge--' + row.sourceTone">{{ row.sourceText }}</span></td>
          <td class="is-num">{{ row.employeesText }}</td>
          <td class="is-num">{{ row.managersText }}</td>
          <td class="is-num">{{ row.punchDaysText }}</td>
          <td class="is-num">{{ row.weekText }}</td>
          <td>{{ row.stageText }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="pi-cards pi-obc__cards">
      <pi-kpi-card label="Ativação de usuário (7 dias)" :metric="view.userActivation" definition-key="user_activation_7d"
                   info-key="activation.userActivation" :definition-version="definitionVersion" :compare="false">
        <p class="pi-obc__hint">Usuários criados na empresa que fizeram a 1ª ação significativa em até 7 dias.</p>
      </pi-kpi-card>
    </div>
    <p class="pi-muted pi-obc__note">{{ rulesNote }}</p>
    <slot/>
  </div>
</template>

<script>
import piKpiCard from "./piKpiCard.vue";
import piTh from "./piTh.vue";
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import piOnboardingChecklist from "./piOnboardingChecklist.vue";
import { screenColumns } from "./piColumns.js";
import { ONBOARDING_WINDOW_COLUMNS, RULES_NOTE } from "./piOnboardingModel.js";

export default {
  name: "pi-onboarding-company",
  components: { piKpiCard, piTh, piDefinitionTooltip, piOnboardingChecklist },
  props: {
    view: { type: Object, required: true },
    definitionVersion: { type: Number, default: null },
  },
  data() {
    return { rulesNote: RULES_NOTE };
  },
  computed: {
    company() {
      return this.view.company;
    },
    windowColumns() {
      return screenColumns(ONBOARDING_WINDOW_COLUMNS);
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-obc__facts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 0 0 14px;
}

.pi-obc__fact dt {
  font-size: 11px;
  font-weight: 700;
  color: #4e5560;
  text-transform: uppercase;
}

.pi-obc__fact dd {
  margin: 0;
  font-size: 13px;
  color: #1f2933;
}

.pi-obc__cards {
  margin-top: 14px;
}

.pi-obc__hint {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.pi-obc__note {
  margin: 0 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piOnboardingCompany.vue